import { IPreloadedState } from 'shared/types/redux';

export const selectExperiments = (state: IPreloadedState) => state.experiments;
